// Donations list page (CHG-1243 / ITER-3366).
//
// Thin per the v9 brief: page files ≤30 LOC, all configuration in
// @generated/screens. Future generator regenerates donationListConfig
// from donation.entity-hint.yaml (CHG-1228) without touching this file.
//
// Spec: specs/tier-05-experience/donations-v2.cross-screen.yaml.

import { ListPage } from "../components/composition";
import { donationListConfig } from "../generated/screens/donation-list";

export function Donations() {
  return <ListPage config={donationListConfig} />;
}
